import {
    MarkerStyle,
    WaveFormStyle,
} from '@accurate-player/accurate-player-components-external';

export const userMarkerStyling: MarkerStyle = {
    backgroundColor: '#875d09',
    opacity: 1,
    selected: {
        backgroundColor: '#ffd37c',
        opacity: 1,
    },
    hover: {
        backgroundColor: '#fff1d5',
        opacity: 1,
    },
};

export const normalMarkerStyling: MarkerStyle = {
    backgroundColor: '#0e7171',
    opacity: 1,
    selected: {
        backgroundColor: '#9acfcf',
        opacity: 1,
    },
    hover: {
        backgroundColor: '#d9eded',
        opacity: 1,
    },
};

export const captionMarkerStyling: MarkerStyle = {
    backgroundColor: '#2c52ab',
    opacity: 1,
    selected: {
        backgroundColor: '#95a8d5',
        opacity: 1,
    },
    hover: {
        backgroundColor: '#d5dcee',
        opacity: 1,
    },
};

export const disabledMarkerStyling: MarkerStyle = {
    backgroundColor: '#fff',
    opacity: 0.2,
    selected: {
        backgroundColor: '#fff',
        opacity: 0.2,
    },
    hover: {
        backgroundColor: '#fff',
        opacity: 0.2,
    },
};

export enum ThemeMarkerType {
    User = 'User',
    Normal = 'Normal',
    Captions = 'Captions',
}

export const getMarkerStyling = (markerType: ThemeMarkerType, enabled: boolean): MarkerStyle => {
    if (!enabled)
        return disabledMarkerStyling;
    
    if (markerType === ThemeMarkerType.User)
        return userMarkerStyling;
    
    if (markerType === ThemeMarkerType.Captions)
        return captionMarkerStyling;
    
    return normalMarkerStyling;
};

export const activeStyling = {
    fill: '--ap-marker-caption',
    stroke: '--ap-marker-caption',
};

export const normalStyling = {
    fill: '--ap-secondary',
    stroke: '--ap-secondary',
};

export const getWaveformStyling = (active: boolean): WaveFormStyle => {
    if (active) {
        return activeStyling;
    }
    return normalStyling;
};
